import { useQuery } from '@tanstack/react-query'
import { fetchLivingComplex } from '../../../api/core/livingComplex'
import { LivingComplex } from '../../../entities/LivingComplex'

export const useLivingComplex = (livingComplexId: string) =>
  useQuery<LivingComplex>({
    queryKey: ['living-complex', livingComplexId],
    queryFn: () => fetchLivingComplex(livingComplexId),
    enabled: !!livingComplexId,
    staleTime: Infinity
  })
